import { Badge, Button, Dropdown, List } from "antd";
import { darken } from "polished";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledNotifyWrapper = styled.div<{ height: number }>`
  height: ${({ height }) => `${height}px`};
`;

export const StyledNotifyDropdown = styled(Dropdown)`
  font-size: inherit;

  .ant-dropdown-menu {
    padding: 0;
    background-color: ${({ theme }) =>
      darken(0.05, theme.palette.background.paper)} !important;

    .ant-dropdown-menu-item:first-child {
      span {
        background-color: ${({ theme }) =>
          darken(0.05, theme.palette.background.paper)} !important;
      }
    }
  }
`;

export const StyledNotifyScrollSubmenu = styled.div`
  height: 350px;
  padding: 0;
  overflow-x: hidden;
`;

export const StyledNotifyList = styled(List)`
  padding-top: 0;
  padding-bottom: 0;

  .ant-list-item:nth-child(odd) {
    background-color: ${({ theme }) =>
      darken(0.03, theme.palette.background.paper)} !important;
    &:hover {
      background-color: ${({ theme }) =>
        darken(0.05, theme.palette.background.paper)} !important;
    }
  }
`;

export const StyledNotifyButtonAll = styled(Link)`
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  width: 100%;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: inherit;
  border-radius: 0;
  color: ${({ theme }) => theme.palette.white} !important;
  background-color: ${({ theme }) => theme.palette.primary.main} !important;
  text-decoration: none;
  padding: 7px;

  &:hover {
    background-color: ${({ theme }) =>
      darken(0.05, theme.palette.primary.main)} !important;
  }
`;

export const StyledNotifyBadge = styled(Badge)`
  display: flex;

  & .ant-badge-count {
    max-width: 22px;
  }
`;

export const StyledNotifyIcon = styled.span`
  position: relative;
  font-size: inherit;
`;

export const StyledMarkAllAsReadButton = styled(Button)`
  padding: 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  background-color: transparent !important;
`;
